import { FuelTypography } from "@frete.com/fuel-react"
import styled from "styled-components"

export default styled(FuelTypography).attrs({ size: 'caption', color: 'danger-default' })`
  margin-left: ${({ theme }) => theme.spacing.km1};
  margin-top: ${({ theme }) => theme.spacing.km1};
  display: block;
`
